import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';

import { GuestCartActions } from '../actions';
import { IGuestCart, IGuestCartResponse } from '../models/guest.models';
import { PayloadUtils } from '../utils/payload.utils';
import { GuestUtils } from '../utils/guest.utils';

export interface GuestCartState {
  guestCart: IGuestCart,
}

export const initialState: GuestCartState = {
  guestCart: null,
};

export const guestCartBaseState = createFeatureSelector<GuestCartState>('guestCart');

export const selectGuestCart = createSelector(
  guestCartBaseState,
  state => state.guestCart,
);

export const selectAddressFromGuestCart = createSelector(
  guestCartBaseState,
  state => GuestUtils.createIAddressFromIGuestCart(state.guestCart),
);

export const selectCustomerCheckoutDataFromGuestCart = createSelector(
  guestCartBaseState,
  state => GuestUtils.createICustomerCheckoutDataFromIGuestCart(state.guestCart),
);

export const selectCartAttributesFromGuestCart = createSelector(
  guestCartBaseState,
  state => GuestUtils.createICartAttributesFromIGuestCart(state.guestCart),
);

export const GuestCartReducer = createReducer(
  initialState,
  on(GuestCartActions.loadGuestCart, (state: GuestCartState) => {
    return {
      ...state,
      guestCart: null,
    };
  }),
  on(GuestCartActions.loadGuestCartSuccess, (state: GuestCartState, action) => {
    return {
      ...state,
      guestCart: mapIGuestCartResponseToIGuestCart(action.guestCartResponse),
    };
  }),
);

function mapIGuestCartResponseToIGuestCart(guestCartResponse: IGuestCartResponse): IGuestCart {
  return {
    data: guestCartResponse.data,
    items: guestCartResponse.included ? PayloadUtils.getItemsWithDetailsFromInclude(
      guestCartResponse.included,
      false,
      ['concrete-products', 'concrete-product-image-sets', 'guest-cart-items'],
      'guest-cart-items',
    ) : [],
  } as IGuestCart;
}
